// import { KeyboardEventHandler } from "react";
import { chakra, useCheckbox, UseCheckboxProps, useStyleConfig, StyleProps } from "@chakra-ui/react";
import type { SystemStyleObject } from "@chakra-ui/theme-tools";
import { EnumTagColor } from "src/types/common-enum";

const FILTER_TAG_CHECKBOX_TEST_ID = "filter-tag-checkbox";

export type IFilterTagCheckbox = {
    readonly label: string;
    color: Readonly<EnumTagColor>;
    onKeyDown?: (event: React.KeyboardEvent<HTMLLabelElement>) => void;
};

/**
 * Checkbox with button like styles
 */
export const FilterTagCheckbox = ({ color, label, onKeyDown, ...props }: IFilterTagCheckbox & UseCheckboxProps) => {
    const { state, getInputProps } = useCheckbox(props);
    // Artificially added the _hover property to the type. Without it there is the following error reported:
    // '_hover' does not exist on type 'SystemStyleObject'. This is a known issue tracked here https://github.com/chakra-ui/chakra-ui/issues/6261.
    const buttonStyles = useStyleConfig("Button", { variant: "outline", size: "xs", colorScheme: color }) as SystemStyleObject & {
        _hover: StyleProps;
    };

    return (
        <chakra.label
            cursor="pointer"
            data-test-id={FILTER_TAG_CHECKBOX_TEST_ID}
            rounded="16px"
            sx={{
                _hover: { bg: [null, null, buttonStyles._hover.bg] },
                _focus: { bg: state.isChecked ? `${color}.200` : "none" },
            }}
            __css={buttonStyles}
            {...(state.isChecked ? { "data-active": true } : {})}
            tabIndex={0}
            onKeyDown={onKeyDown}
        >
            <input {...getInputProps()} hidden />
            {label}
        </chakra.label>
    );
};
